const {
    REACT_APP_URL_API_NITRO4,
    REACT_APP_URL_API_E2E,
    REACT_APP_URL_API_TRANSACTIONAL,
    REACT_APP_SOCKET_URL,
    REACT_APP_URL_SERVER_BFF,
    REACT_APP_PUBLIC_URL
} = process.env;

export default {
    NITRO4: REACT_APP_URL_API_NITRO4,
    E2E: REACT_APP_URL_API_E2E,
    TRANSACTIONAL: REACT_APP_URL_API_TRANSACTIONAL,
    SOCKET_URL: REACT_APP_SOCKET_URL,
    PUBLIC_URL: REACT_APP_PUBLIC_URL,
    SERVER_BFF: REACT_APP_URL_SERVER_BFF,
}